<script>
import _ from 'lodash';
import EditableTextArea from '@components/editables/editable-text-area.vue';
import { authComputed, authMethods, clientComputed, clientMethods, trainerComputed } from '@state/helpers';

export default {
  name: 'PersonalMotivationnMobile',
  components: {
    EditableTextArea,
  },
  data() {
    return {
      motivation: '',
      updatingClient: false,
    };
  },
  mounted() {
    this.initalizeLocalState();
  },
  methods: {
    ...authMethods,
    ...clientMethods,
    initalizeLocalState() {
      this.motivation = this.userProfile.motivation;
    },
    async handleSubmitPersonalMotivation() {
      this.updatingClient = true;

      const payload = {
        client: {
          profile: {
            ...this.userProfile,
            motivation: this.motivation,
          },
        },
      };
      const response = await this.updateClient({ clientId: this.clientId, trainerId: this.trainerId, payload });

      if (response.success === false) {
        console.error('response: ', response);
      } else {
        const updatedUser = _.cloneDeep(this.currentUser);
        updatedUser.user = response.client;
        this.setCurrentUser(updatedUser);

        await this.updateOnboardingProgress(3);
        this.$router.push({ name: 'personalCurrentWeight' }).catch((err) => {
          if (err !== undefined) {
            console.error(err);
          }
        });
      }

      this.updatingClient = false;
    },
  },
  computed: {
    ...authComputed,
    ...clientComputed,
    ...trainerComputed,
  },
};
</script>

<template>
  <div class="container">
    <div class="sub-container">
      <div class="form content">
        <form @submit.prevent="handleSubmitPersonalMotivation">
          <div id="textareaWidth" class="textarea-container">
            <EditableTextArea
              id="motivation"
              placeholderTxt="  Start typing"
              :enableAutoExpand="true"
              :text="motivation ? motivation : ''"
              color="light"
              mode="edit"
              @update-editable-value="motivation = $event"
            />
          </div>
          <div class="buttons">
            <div id="back">
              <router-link to="/signup/personal-goals">
                <BaseButton class="large-transparent">
                  <img src="@assets/images/icons/left-arrow.svg" />
                  Back
                </BaseButton>
              </router-link>
            </div>
            <div id="next">
              <BaseButton class="large" type="submit" :disabled="updatingClient">
                Next
                <img src="@assets/images/icons/right-arrow.svg" />
              </BaseButton>
            </div>
          </div>
        </form>
      </div>
      <div class="header">
        <BaseProgressBar :limit="7" :progress="3" class="base-progress-bar" />
        <div class="title">
          <h1>What’s your motivation?</h1>
        </div>
        <div class="subtitle">
          <p>
            Every goal starts with a ‘why’! Getting ready for the beach or do you need to look good in that wedding dress? Tell me
            what you’re after.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.container {
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-bottom: 2rem;
  padding-left: unset;
  padding-right: unset;
  width: 100%;
  .sub-container {
    display: flex;
    flex-direction: column-reverse;
    .header {
      margin: 0;
      padding-left: 15px;
      padding-right: 15px;
      text-align: start;
      width: 100%;
      .base-progress-bar {
        margin-left: 6.4%;
        margin-top: 19.2%;
        width: 87.2%;
      }

      .title {
        align-self: center;
        font-family: $base-font-family;
        font-size: 18px;
        width: 100%;

        h1 {
          color: black;
          font-size: 36px;
          letter-spacing: -0.761905px;
          line-height: 42px;
          margin: 17.8% 9.75% 0 6.4%;
        }
      }

      .subtitle {
        color: black;
        font-family: $secondary-font-family;
        font-size: 16px;
        margin: 0;
        width: 100%;

        p {
          line-height: 1.38;
          margin: 0;
          margin-top: 3.25%;
          padding: 0 21px 0 27px;
        }
      }
    }
    .form {
      display: block;
      margin-top: 18%;
      text-align: center;

      form {
        height: 100%;
        width: 100%;
        ::v-deep label {
          font-family: $proxima-nova;
          font-weight: 600;
        }
        ::v-deep input {
          font-family: $proxima-nova;
          font-weight: normal;
          &::placeholder {
            font-family: $proxima-nova;
            font-weight: normal;
          }
        }
        .textarea-container {
          margin-left: auto;
          padding-bottom: 10rem;
          width: 80%;
          #motivation {
            margin-left: 9.25%;
            width: 100%;
            ::v-deep textarea {
              border-block-end: 2px solid rgba(#c4c4c4, 0.5);
              color: $color-action;
              font-family: $proxima-nova;
              font-size: 32px;
              font-style: normal;
              font-weight: normal;
              line-height: 40px;
              margin-left: auto;
              width: 80%;
              &::placeholder {
                /* Chrome, Firefox, Opera, Safari 10.1+ */
                color: rgba(black, 0.3);
                font-family: $proxima-nova;
                font-size: 32px;
                font-style: normal;
                font-weight: normal;
                line-height: 5rem;
                opacity: 0.35;
              }
            }
          }
        }
        .buttons {
          bottom: 43px;
          padding-left: 15px;
          padding-right: 15px;
          position: fixed;
          width: 100%;
          button:disabled {
            background-color: lighten($color: #4059e1, $amount: 20);
          }

          #next {
            float: right;
            margin-right: 7%;
            width: 37%;
          }

          #back {
            float: left;
            margin-right: 9%;
            width: 34.75%;

            .large-transparent {
              color: #000;
            }
          }
        }
      }
    }
  }
}
</style>
